import { render, staticRenderFns } from "./formPatent.vue?vue&type=template&id=2519c3e8&scoped=true&"
import script from "./formPatent.vue?vue&type=script&lang=js&"
export * from "./formPatent.vue?vue&type=script&lang=js&"
import style0 from "./formPatent.vue?vue&type=style&index=0&id=2519c3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519c3e8",
  null
  
)

export default component.exports